import { useEffect } from "react";

export function useOnClickOutside(ref, handler) {
	useEffect(() => {
		function listener(e) {
			const el = ref.current;
			if (!el || el.contains(e.target)) return;
			handler(e);
		}
		document.addEventListener("mousedown", listener);
		document.addEventListener("touchstart", listener, { passive: true });
		return () => {
			document.removeEventListener("mousedown", listener);
			document.removeEventListener("touchstart", listener);
		};
	}, [ref, handler]);
}

export function cx(...parts) {
	return parts.filter(Boolean).join(" ");
}

export function cycleIndex(current, delta, length) {
	if (!Number.isInteger(length) || length <= 0) return -1;
	const base = Number.isInteger(current) && current >= 0 ? current : -1;
	const next = base + delta;
	if (next < 0) return length - 1;
	if (next >= length) return 0;
	return next;
}
